exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".w-90 {\n  width: 91% !important;\n}\n.W-99 {\n  width: 99% !important;\n}\n", ""]);

